import { Button, Form, Input } from "antd";
import { FormComponentProps } from "antd/lib/form";
import * as React from "react";

export interface ISavePredictionFormProps extends FormComponentProps {
  handleSavePrediction: (predictionName: string) => void;
}

// tslint:disable-next-line: no-empty-interface
export interface ISavePredictionFormState {}

class SavePredictionForm extends React.Component<
  ISavePredictionFormProps,
  ISavePredictionFormState
> {
  constructor(props: ISavePredictionFormProps) {
    super(props);

    this.state = {};

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  public componentDidMount() {
    // To disabled submit button at the beginning.
    this.props.form.validateFields();
  }

  public render() {
    const {
      getFieldDecorator,
      getFieldsError,
      getFieldError,
      isFieldTouched
    } = this.props.form;
    // Only show error after a field is touched.
    const predictionNameError =
      isFieldTouched("predictionName") && getFieldError("predictionName");

    return (
      <Form layout="inline" onSubmit={this.handleSubmit}>
        <Form.Item
          validateStatus={predictionNameError ? "error" : undefined}
          help={predictionNameError || ""}
        >
          {getFieldDecorator("predictionName", {
            rules: [
              {
                message: "Please input a name for the prediction",
                required: true
              }
            ]
          })(<Input placeholder="Name of Prediction" />)}
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            disabled={this.hasErrors(getFieldsError())}
          >
            Save Prediction
          </Button>
        </Form.Item>
      </Form>
    );
  }

  private handleSubmit(e: React.FormEvent<any> | undefined) {
    // tslint:disable-next-line: no-unused-expression
    e && e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (values.predictionName) {
          this.props.handleSavePrediction(values.predictionName);
        }
      }
    });
  }

  private hasErrors(fieldsError: any) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
  }
}

const exportedForm = Form.create<ISavePredictionFormProps>()(
  SavePredictionForm
);
export default exportedForm;



// WEBPACK FOOTER //
// ./src/components/PredictionPage/SavePredictionForm.tsx